import React from 'react';
import ListExpertise from './listExpertise';

// La liste porte désormais sa propre coquille : cet enrobage n'ajoute rien.
function Expmanage() {
  return <ListExpertise />;
}

export default Expmanage;
